export default "__VITE_ASSET__FKxVKJBs__"